import { createAction, props } from '@ngrx/store';
import { queryParam } from 'src/app/models/config.interface';


export const enablePage = createAction(
  '[App Component] Enable or disable page',
  props<{
    disablePage: boolean,
    stopLoadingSpinner: boolean,
    noConfigData: boolean
  }>()
);

export const enableConfigAPI = createAction(
  '[App Component] Enable or disable config API calls',
  props<{
    enableConfigAPI: boolean
  }>()
);

export const loadQueryParameters = createAction(
  '[App Component] Provision query parameters',
  props<{user: queryParam, id: queryParam, project: queryParam, key: queryParam, lng: queryParam, country: queryParam, RID:queryParam }>()
);